export const cancellationTypes = {
  ADDON: 'addon',
  HOSTING: 'hosting',
  DOMAIN: 'domain',
  ID_PROTECT: 'domainaddon',
}

export const timeframeActions = {
  CANCEL_NOW: 'cancel_now',
}
